import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Alert } from "react-bootstrap";

const FeedbackBanner = ({ show, message, variant, onClose }) => {
  const [visible, setVisible] = useState(false);
  const [bannerClass, setBannerClass] = useState("slide-banner-hide");

  useEffect(() => {
    let showTimeout;
    let autoDismissTimeout;

    if (show) {
      setVisible(true); // Mount the banner
      showTimeout = setTimeout(() => {
        setBannerClass("slide-banner-show"); // Animate in
      }, 10);

      autoDismissTimeout = setTimeout(() => {
        handleClose();
      }, 3000); // Auto-dismiss after 3s
    } else {
      setBannerClass("slide-banner-hide");
      setTimeout(() => {
        setVisible(false); // Unmount after fade
      }, 400); // Match CSS duration
    }

    return () => {
      clearTimeout(showTimeout);
      clearTimeout(autoDismissTimeout);
    };
  }, [show]);

  const handleClose = () => {
    setBannerClass("slide-banner-hide");
    setTimeout(() => {
      setVisible(false);
      onClose();
    }, 400);
  };

  const getIcon = () => {
    switch (variant) {
      case "success":
        return <i className="fas fa-check-circle text-success me-2" />;
      case "danger":
        return <i className="fas fa-times-circle text-danger me-2" />;
      case "warning":
        return <i className="fas fa-exclamation-triangle text-warning me-2" />;
      case "info":
        return <i className="fas fa-info-circle text-info me-2" />;
      default:
        return <i className="fas fa-info-circle text-secondary me-2" />;
    }
  };

  if (!visible) return null;

  return (
    <div className={classNames("slide-banner-wrapper", bannerClass)}>
      <Alert
        variant={variant}
        className="d-flex justify-content-between align-items-center mb-0"
      >
        <div className="d-flex align-items-center">
          {getIcon()}
          <span>{message}</span>
          <button
            type="button"
            className="custom-close-btn"
            onClick={handleClose}
          >
            &times;
          </button>
        </div>
      </Alert>
    </div>
  );
};

FeedbackBanner.propTypes = {
  show: PropTypes.bool.isRequired,
  message: PropTypes.string,
  variant: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

FeedbackBanner.defaultProps = {
  message: "",
  variant: "success",
};

export default FeedbackBanner;
